module.exports = __webpack_public_path__ + "static/media/me-bg-laugh.df94de5b.jpg";